import { useDashboardFeatureFlags } from '@components';
import { useSubscription } from './useSubscription';
import { useTopSubscriptionPlan } from './useTopSubscriptionPlan';
const isUnlimited = (limit) => limit === -1;
const VISIBILITY_THRESHOLD_PERCENTAGE = 50;
const NEAR_LIMIT_THRESHOLD_PERCENTAGE = 90;
export const useSubscriptionStorageLimits = () => {
    const { activeSubscription } = useSubscription();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { topSubscriptionPlan } = useTopSubscriptionPlan();
    // Digital products storage
    const digitalProductsStorageUsage = activeSubscription?.digitalProductsStorageBytes.usage || 0;
    const digitalProductsStorageLimit = activeSubscription?.digitalProductsStorageBytes.limit || 0;
    const isConditionallyVisible = activeSubscription?.plan.tag &&
        ['DEFAULT_UNLIMITED', 'DEFAULT_LEGACY', 'PRO_UNLIMITED'].includes(activeSubscription.plan.tag)
        ? (digitalProductsStorageUsage * 100) / digitalProductsStorageLimit >=
            VISIBILITY_THRESHOLD_PERCENTAGE
        : true;
    const digitalProductsStorageEnabled = dashboardFeatureFlags.subscriptionsStorageLimits.enabled && isConditionallyVisible;
    const isDigitalProductStorageUnlimited = isUnlimited(digitalProductsStorageLimit);
    const isDigitalProductStorageLimitReached = isDigitalProductStorageUnlimited
        ? false
        : digitalProductsStorageUsage >= digitalProductsStorageLimit;
    const isDigitalProductStorageNearLimit = isDigitalProductStorageUnlimited || isDigitalProductStorageLimitReached
        ? false
        : digitalProductsStorageUsage >=
            (NEAR_LIMIT_THRESHOLD_PERCENTAGE / 100) * digitalProductsStorageLimit;
    // Product designer storage
    const productDesignerStorageEnabled = dashboardFeatureFlags.subscriptionsStorageLimits.enabled &&
        dashboardFeatureFlags.subscriptionsProductDesignerStorageLimits.enabled;
    const productDesignerStorageUsage = 845634769; // TODO: get from backend
    const productDesignerStorageLimit = activeSubscription?.plan.productDesignerArtworkStorageLimitBytes || 0;
    const isProductDesignerStorageUnlimited = isUnlimited(productDesignerStorageLimit);
    const isProductDesignerStorageLimitReached = isProductDesignerStorageUnlimited
        ? false
        : productDesignerStorageUsage >= productDesignerStorageLimit;
    const isProductDesignerStorageNearLimit = isProductDesignerStorageUnlimited || isProductDesignerStorageLimitReached
        ? false
        : productDesignerStorageUsage >=
            (NEAR_LIMIT_THRESHOLD_PERCENTAGE / 100) * productDesignerStorageLimit;
    return {
        digitalProductsStorage: {
            enabled: digitalProductsStorageEnabled,
            usage: digitalProductsStorageUsage,
            limit: digitalProductsStorageLimit,
            isUnlimited: isDigitalProductStorageUnlimited,
            isNearLimit: isDigitalProductStorageNearLimit,
            isLimitReached: isDigitalProductStorageLimitReached,
            topSubscriptionPlanLimit: topSubscriptionPlan?.digitalProductsStorageLimitBytes || 0,
            canAddFile: (fileSize) => !digitalProductsStorageEnabled && isDigitalProductStorageUnlimited
                ? true
                : digitalProductsStorageUsage + fileSize <= digitalProductsStorageLimit,
        },
        productDesignerStorage: {
            enabled: productDesignerStorageEnabled,
            usage: productDesignerStorageUsage,
            limit: productDesignerStorageLimit,
            isUnlimited: isProductDesignerStorageUnlimited,
            isNearLimit: isProductDesignerStorageNearLimit,
            isLimitReached: isProductDesignerStorageLimitReached,
            topSubscriptionPlanLimit: topSubscriptionPlan?.productDesignerArtworkStorageLimitBytes || 0,
        },
    };
};
